import React, {useContext} from "react";
import {Layout, Menu} from "antd";
import "./MainApp.css";
import {withRouter, Switch, Route, Redirect} from "react-router-dom";
import ShippingOrderForm from "./ShippingOrders/ShippingOrderForm/ShippingOrderForm";
import ShippingOrdersImportFile from "./ShippingOrders/ShippingOrdersImportFile/ShippingOrdersImportFile";
import ShippingOrdersView from "./ShippingOrders/ShippingOrders";
import Users from "./Users/Users"; // Import the Users component
import Admin from "./Admin/Admin";
import UserContext from "../UserContext";
import Logo from "../Logo";

import UserMenu from "./Common/UserMenu";

import Usertypes from "./Common/UserTypes";
import ShippingOrderFormConfig from "./Config/ShippingOrderFormConfig";
import ShippingOrderSettings from "./Config/ShippingOrderSettings";

const {Header, Footer, Content} = Layout;

function MainApp(props) {
  const context = useContext(UserContext);

  const logout = (e) => {
    if (e) {
      e.preventDefault();
    }
    context.setCurrentUser(null);
  };

  const redirectToUpdatePassword = (e) => {
    if (e) {
      e.preventDefault();
    }
    props.history.push("/update-password");
  };

  if (!context.currentUser) {
    return <Redirect to="/login"/>;
  }

  return (
    <div>
      <Layout className="layout">
        <Header
          className="header"
          style={{
            borderBottom: "3px solid lightgrey",
            height: "80px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{display: "flex"}}>
            <Logo imgStyle={{height: "75px", padding: "5px"}}/>
            <Menu
              theme="dark"
              mode="horizontal"
              style={{backgroundColor: "#211d70", minWidth: '800px'}}
              defaultSelectedKeys={[props.location.pathname]}
            >
              {context.userType !== Usertypes.Admin && <Menu.Item
                key="/app/shipping-orders/skatoules"
                onClick={() => props.history.push("/app/shipping-orders")}
              >
                Εντολές Μεταφοράς
              </Menu.Item> }

              {context.userType === Usertypes.Admin && <Menu.Item
                key="/app/admin/users"
                onClick={() => props.history.push("/app/admin/users")}
              >
                Χρήστες
              </Menu.Item>}

              {context.userType === Usertypes.Admin && <Menu.Item
                key="/app/admin/config/shipping-orders/form"
                onClick={() => props.history.push("/app/admin/config/shipping-orders/form")}
              >
                Ρυθμίσεις Φόρμας
              </Menu.Item>}

              {context.userType === Usertypes.Admin && <Menu.Item
                key="/app/admin/config/shipping-orders/settings"
                onClick={() => props.history.push("/app/admin/config/shipping-orders/settings")}
              >
                Γενικές Ρυθμίσεις
              </Menu.Item>}

              {context.userType === Usertypes.Admin && <Menu.Item
                key="/app/admin/"
                onClick={() => props.history.push("/app/admin/")}
              >
                Παραμετροποίηση Excel
              </Menu.Item>}

            </Menu>
          </div>
          <UserMenu
            redirectToUpdatePassword={redirectToUpdatePassword}
            logout={logout}
          />
        </Header>
        <Content className="content">
          <div className="content-body">
            <Switch>
              <Route
                path="/app/shipping-orders/form"
                component={ShippingOrderForm}
              />
              <Route
                path="/app/admin/users"
                render={(props) =>
                  context.userType === Usertypes.Admin ? (
                    <Users {...props} />
                  ) : (
                    <Redirect to="/app/shipping-orders"/>
                  )
                }
              />
              <Route
                path="/app/admin/config/shipping-orders/form"
                render={(props) =>
                  context.userType === Usertypes.Admin ? (
                    <ShippingOrderFormConfig {...props} />
                  ) : (
                    <Redirect to="/app/shipping-orders"/>
                  )
                }
              />
              <Route
                path="/app/admin/config/shipping-orders/settings"
                render={(props) =>
                  context.userType === Usertypes.Admin ? (
                    <ShippingOrderSettings {...props} />
                  ) : (
                    <Redirect to="/app/shipping-orders"/>
                  )
                }
              />
              <Route
                path="/app/shipping-orders/file-import"
                component={ShippingOrdersImportFile}
              />
              <Route
                path="/app/shipping-orders/view"
                component={ShippingOrdersView}
              />
              <Route
                path="/app/shipping-orders"
                component={ShippingOrdersView}
              />
              <Route path="/app/admin"
                     render={(props) =>
                       context.userType === Usertypes.Admin ? (
                         <Admin {...props} />
                       ) : (
                         <Redirect to="/app/shipping-orders"/>
                       )
                     }
              />
              <Route path="/app">
                {context.userType === Usertypes.Admin ? (
                  <Redirect push to="/app/admin/users"/>
                ) : (
                  <Redirect push to="/app/shipping-orders"/>
                )}
              </Route>
              <Route path="/">
                {context.userType === Usertypes.Admin ? (
                  <Redirect push to="/app/admin/users"/>
                ) : (
                  <Redirect push to="/app/shipping-orders"/>
                )}
              </Route>
            </Switch>
          </div>
        </Content>

        <Footer
          style={{
            textAlign: "right",
            backgroundColor: "gainsboro",
            borderTop: "3px solid lightgray",
          }}
        >
          Delatolas Courier 2021 &#169;
        </Footer>
      </Layout>
    </div>
  );
}

export default withRouter(MainApp);
